/**
 * 初始化的loading页面
 */

import * as React from 'react'
import styles from './index.module.less'

const { useEffect, useRef } = React

export default function Loader() {
  const timerRef = useRef<any>(null)
  const loadingRef = useRef<any>(null)

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      if (loadingRef.current) {
        loadingRef.current.style.opacity = 0
      }
    }, 1000)

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [])

  return (
    <div ref={loadingRef} className={styles.loader}>
      <img src="https://static.creativebooster.com/common/logo-w.png" alt="logo" />
    </div>
  )
}
